import clsx from 'clsx';
import { Component } from '@headless-workspace/typings';
import { cva } from 'class-variance-authority';
import type { GlowTagProps, TagSize } from '../../atoms';
import { GlowTag, GlowTextBodySmall, GlowTextCaption } from '../../atoms';
import { IconName } from '../../res/icons';

type GlowTagExtendedProps = Omit<GlowTagProps, 'shape' | 'stretch' | 'size' | 'iconName'> & {
    extendedLabel: string;
    size: TagSize;
    iconName?: IconName;
    shape?: GlowTagProps['shape'];
    stretch?: boolean;
    className?: string;
};

const extendedStyles = cva('flex items-center bg-background-neutral text-text-primary rounded-l-none rounded-r-0.25', {
    variants: {
        size: {
            small: 'px-0.25 py-0.125',
            medium: 'px-0.5 py-0.25',
            large: 'px-0.5 py-0.375',
        },
    },
    defaultVariants: {
        size: 'medium',
    },
});

export const GlowTagExtended: Component<GlowTagExtendedProps> = ({
    extendedLabel,
    className,
    shape = 'left',
    stretch = true,
    size,
    iconName,
    ...tagProps
}) => {
    const LabelComponent = size === 'large' ? GlowTextBodySmall : GlowTextCaption;

    return (
        <div className={clsx('inline-flex items-stretch', className)}>
            <GlowTag {...tagProps} size={size} iconName={iconName} shape={shape} stretch={stretch} />
            <div className={extendedStyles({ size })}>
                <LabelComponent text={extendedLabel} className={'text-inherit'} />
            </div>
        </div>
    );
};
